var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "withdrawal_management" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("活动管理")]),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          { staticStyle: { "margin-left": "0" } },
          [
            _c("el-input", {
              attrs: { placeholder: "输入活动名称查询", clearable: "" },
              model: {
                value: _vm.queryData.activityName,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "activityName", $$v)
                },
                expression: "queryData.activityName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择活动状态", clearable: "" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: 0, label: "未开始" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 1, label: "进行中" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 2, label: "已结束" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", height: "40px" },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { height: "40px" },
                attrs: { type: "primary" },
                on: { click: _vm.onInquire },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                staticStyle: { height: "40px" },
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onInitialize },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新增+")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "24px" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticStyle: {
              display: "flex",
              "justify-content": "flex-start",
              "flex-wrap": "wrap",
            },
          },
          _vm._l(_vm.tableData, function (item) {
            return _c("ItemActivity", {
              key: item.id,
              staticStyle: {
                width: "19%",
                "margin-right": "1%",
                "margin-top": "20px",
              },
              attrs: { item: item },
              on: {
                controls: function ($event) {
                  return _vm.controls($event)
                },
              },
            })
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "活动" + (_vm.eventsType === "add" ? "添加" : "编辑"),
            visible: _vm.dialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.dialogVisible
            ? _c("div", { staticClass: "fc" }, [
                _c("div", { staticStyle: { width: "800px" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          staticClass: "demo-ruleForm",
                          attrs: {
                            model: _vm.ruleForm,
                            rules: _vm.rules,
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动名称",
                                prop: "activityName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.ruleForm.activityName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "activityName", $$v)
                                  },
                                  expression: "ruleForm.activityName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "目标用户",
                                prop: "targetUserType",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.ruleForm.targetUserType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "targetUserType",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.targetUserType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("所有人"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v("指定等级"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.ruleForm.targetUserType === 3
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "", prop: "targetUserGrade" },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            multiple: "",
                                            placeholder: "请选择",
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.ruleForm.targetUserGrade,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "targetUserGrade",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.targetUserGrade",
                                          },
                                        },
                                        _vm._l(
                                          _vm.classListData,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                  注：指定等级可多选；用户等级变更后，原等级状态下的购买记录会计入次数。\n                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "头图", prop: "mainPic" } },
                            [
                              _c(
                                "div",
                                { staticClass: "frb" },
                                [
                                  _c("upload", {
                                    attrs: {
                                      name: "mainPic",
                                      "img-url": _vm.ruleForm.mainPic,
                                    },
                                    on: {
                                      pictureAddress: function ($event) {
                                        return _vm.onPictureAddress($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "背景色值",
                                prop: "backgroundColor",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请输入色号，例:“#FFFFFF”,默认颜色: “#FFFFF”",
                                },
                                model: {
                                  value: _vm.ruleForm.backgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "backgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.backgroundColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "选中字体色",
                                prop: "selectColor",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请输入字体色，例：“#FFFFFF”,默认颜色: “#333333",
                                },
                                model: {
                                  value: _vm.ruleForm.selectColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "selectColor", $$v)
                                  },
                                  expression: "ruleForm.selectColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "未选中字体色",
                                prop: "defaultColor",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "请输未选中字体色，例：“#FFFFFF”,默认颜色: “#666666",
                                },
                                model: {
                                  value: _vm.ruleForm.defaultColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "defaultColor", $$v)
                                  },
                                  expression: "ruleForm.defaultColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "活动规则文案", prop: "ruleTxt" },
                            },
                            [
                              _vm.dialogVisible
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          border: "1px solid #ccc",
                                        },
                                      },
                                      [
                                        _c("Toolbar", {
                                          staticStyle: {
                                            "border-bottom": "1px solid #ccc",
                                          },
                                          attrs: {
                                            editor: _vm.editor,
                                            "default-config": _vm.toolbarConfig,
                                            mode: _vm.mode,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("Editor", {
                                          staticStyle: {
                                            height: "450px",
                                            "overflow-y": "hidden",
                                          },
                                          attrs: {
                                            "default-config": _vm.editorConfig,
                                            mode: _vm.mode,
                                          },
                                          on: { onCreated: _vm.onCreated },
                                          model: {
                                            value: _vm.ruleForm.ruleTxt,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "ruleTxt",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.ruleTxt",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动时间" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options": _vm.pickerOptions,
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "default-time": ["00:00:00", "23:59:59"],
                                },
                                model: {
                                  value: _vm.ruleForm.timeArray,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "timeArray", $$v)
                                  },
                                  expression: "ruleForm.timeArray",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#F59A23",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "请选择活动时间（未选择时间时默认为长期有效状态）"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm("ruleForm")
                                    },
                                  },
                                },
                                [_vm._v("确认")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetForm("ruleForm")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.page.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }